// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".base-container{\n  display:flex;\n  height:100%;\n  flex-direction:column\n}\n.base-container__header{\n  flex:1 0 auto;\n  box-sizing:border-box\n}\n.base-container__main-container{\n  position:relative;\n  overflow:hidden;\n  flex:1 1 auto;\n  display:flex\n}\n.base-container__footer{\n  flex:1 0 auto\n}\n.loader{\n  height:683px\n}\n.loader__mobile{\n  height:817px!important\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
